import { useEffect } from 'react';
import { useCTVModal } from './useCTVModal.tsx';
import { useCTVPopupActions } from './useCTVPopupActions.ts';
import { useIsVideoStateCTVEquivalent } from './useIsVideoStateCTVEquivalent.ts';

export const useCTVPopup = () => {
  const shouldShowPopup = useIsVideoStateCTVEquivalent();
  const { showCTVModal } = useCTVModal();
  const { onConfirmed, onCancel } = useCTVPopupActions();

  useEffect(() => {
    if (shouldShowPopup)
      showCTVModal({
        onConfirmed: onConfirmed,
        onCancel: onCancel,
      });
  }, [shouldShowPopup, onConfirmed, onCancel, showCTVModal]);
};
